import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HMDAPortal from './pages/HMDA/HMDAPortal';
import VenuePaymentSuccess from './pages/HMDA/VenuePaymentSuccess';
import VenuePaymentCancelled from './pages/HMDA/VenuePaymentCancelled';
import BookingReceipt from './pages/BookingReceipt';

function App() {
  return (
    <Routes>
      {/* Main HMDA Portal Page */}
      <Route path="/" element={<HMDAPortal />} />
      
      {/* Payment Routes */}
      <Route path="/payment/success" element={<VenuePaymentSuccess />} />
      <Route path="/payment/cancelled" element={<VenuePaymentCancelled />} />
      <Route path="/booking-receipt/:bookingId" element={<BookingReceipt />} />
      
      {/* Movie Shooting Booking Page */}
      
      {/* 404 - Not Found */}
      <Route path="*" element={
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'Inter, system-ui, sans-serif'
        }}>
          <h1 style={{ fontSize: '72px', margin: '0', color: '#FF1F8E' }}>404</h1>
          <p style={{ fontSize: '24px', color: '#4B5563' }}>Page Not Found</p>
          <a href="/" style={{
            marginTop: '20px',
            padding: '12px 24px',
            background: '#FF1F8E',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }}>
            Back to Home
          </a>
        </div>
      } />
    </Routes>
  );
}

export default App;